import { render } from "./AssociateShowerHeadsButtons.vue?vue&type=template&id=1edf9a57&scoped=true"
import script from "./AssociateShowerHeadsButtons.vue?vue&type=script&lang=js"
export * from "./AssociateShowerHeadsButtons.vue?vue&type=script&lang=js"

import "./AssociateShowerHeadsButtons.vue?vue&type=style&index=0&id=1edf9a57&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1edf9a57"]])

export default __exports__